import { useState } from "react";
import { Collapse } from "@mui/material";
import Icon from "../../../../assets/Icon";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { formatDateAtTime } from "../../../../utils";

const TrackingDetails = ({ I18n, order }) => {
  const {
    created_at_timestamp,
    customer_courier_name,
    customer_tracking_id,
    supplier_courier_name,
    supplier_tracking_id,
    date_of_purchase,
  } = order || {};

  const [toggle, setToggle] = useState(false);

  const handleCollapse = () => {
    triggerLogEvent(analytics, "sc_order_tracking_click", { customer_tracking_id, expanded: !toggle });
    setToggle((prev) => !prev);
  };

  return (
    <div className="orderDetailCustomerBox">
      <h3 className="darkGrayColor cursorPointer" onClick={handleCollapse}>
        <p className="marginBottom0">{I18n.order_details}</p>
        <p className="marginBottom0">
          <Icon
            data={{
              name: toggle ? "upIcon" : "downIcon",
              viewBox: "0 0 18 9",
              fill: "#414143",
              width: "18",
              height: "9",
            }}
          />
        </p>
      </h3>

      <div className="orderDetailCustomerInnerBox">
        <div className="orderDetailCustomerInnerRow">
          <p className="darkGrayColor fontSize14">
            {I18n.customer_tracking_id}
          </p>
          <p className="barclayBlueColor fontSize14">
            {customer_tracking_id} - {customer_courier_name}
          </p>
        </div>
        <Collapse in={toggle}>
          <div id="collapsePanel">
            <div className="orderDetailCustomerInnerRow">
              <p className="darkGrayColor fontSize14">
                {I18n.seller_tracking_id}
              </p>
              <p className="barclayBlueColor fontSize14">
                {supplier_tracking_id} - {supplier_courier_name}
              </p>
            </div>
            <div className="orderDetailCustomerInnerRow">
              <p className="darkGrayColor fontSize14">{I18n.creation_date}</p>
              <p className="darkGrayColor fontSize14">
                {formatDateAtTime(new Date(created_at_timestamp))}
              </p>
            </div>
            <div className="orderDetailCustomerInnerRow">
              <p className="darkGrayColor fontSize14">{I18n.purchase_date}</p>
              <p className="darkGrayColor fontSize14">
                {formatDateAtTime(new Date(date_of_purchase))}
              </p>
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default TrackingDetails;
